// extracted by mini-css-extract-plugin
module.exports = {"features":"home_features__GjzpB","teachers":"home_teachers__t4Prl","aplications":"home_aplications__1Kooe"};